import React from "react";
import BackArrow from "../../../components/BackArrow";
import moment from "moment";

const TakePicture = (props) => {
  const {
    currentStep,
    stage,
    selfieData,
    openSelfieModal,
    setSelfieData,
    setOpenTakePicture,
    handleSubmit,
  } = props;

  return (
    <div className="tcl-raffles-makati-page tcl-take-pic-page">
      <div className="tcl-raffles-makati-wrapper">
        <BackArrow
          handleClick={() => {
            setSelfieData(null);
            setOpenTakePicture(false);
          }}
        />
        <div className="tcl-raffles-makati-text">
          <h2>
            {currentStep?.label} {stage}
          </h2>
        </div>
        <div className="tcl-take-pic-wrapper">
          <img src={selfieData} alt="" />
          <div className="tcl-take-pic-text">
            <p>{moment().format("MMMM DD, YYYY HH:mm")}</p>
          </div>
        </div>
        <div className="tcl-take-pic-btns d-flex align-items-center gap-3 flex-wrap mt-3 justify-content-center">
          <button
            type="button"
            className="btn btn-danger"
            onClick={() => {
              setSelfieData(null);
              setOpenTakePicture(false);
              openSelfieModal();
            }}
          >
            Erase
          </button>
          <button
            type="button"
            className="btn btn-primary"
            onClick={() => handleSubmit()}
          >
            USE PHOTO
          </button>
        </div>
      </div>
    </div>
  );
};

export default TakePicture;
